import { Injectable } from '@angular/core';
import {SclMapGeoGoogleService} from './scl-map-geo-google.service';
import { SclMapGeoCodeFarmService } from './scl-map-geo-code-farm.service';
import { SclMapGeoHereService } from './scl-map-geo-here.service';
import { SclMapGeoPSMAService } from './scl-map-geo-psma.service';
import { SclMapGeoPsmaFarmService } from './scl-map-geo-psma-farm.service';
import { SclMapGeoVicmapService } from './scl-map-geo-vicmap.service';
import { SclMapGeoDocService } from './scl-map-geo-doc.service';
import {FormbirdInjectorService} from 'formbird-services';
import {SclSearchClientService} from 'formbird-sc-shared';

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoService {

  providerLookUp = null;
  providerReverse = null;
  geoProviders = [];
  cbLookUp = null; cbLookUpErr = null; cbSelectOption = null;
  currentProviderReverseIndex; autocompleteBox;
  currentProviderLookUpIndex = 0;
  country = ''; language = ''; map; EPSG;
  isInit = false;
  initObj;
  setTimeWait = 300;
  MapGeo;
  lookUpGoogle = false;
  contextParam;
  cbRemoveStreet;
  sclMapGeoCodeFarmService; sclMapGeoGoogleService; sclMapGeoHereService;
  sclMapGeoPSMAService; sclMapGeoPsmaFarmService; sclMapGeoVicMapService;
  sclMapGeoDocService;

  constructor(private formbirdInjectorService: FormbirdInjectorService,
    private sclSearchClientService: SclSearchClientService) {
      this.sclMapGeoCodeFarmService = new SclMapGeoCodeFarmService();
      this.sclMapGeoGoogleService = new SclMapGeoGoogleService();
      this.sclMapGeoHereService = new SclMapGeoHereService();
      this.sclMapGeoPSMAService = new SclMapGeoPSMAService(formbirdInjectorService);
      this.sclMapGeoPsmaFarmService = new SclMapGeoPsmaFarmService();
      this.sclMapGeoVicMapService = new SclMapGeoVicmapService();
      this.sclMapGeoDocService = new SclMapGeoDocService(sclSearchClientService);
  }


  init(geocodeSearchService, pInstance, map, EPSG, options) {
    if (this.isInit) { return; }
    let googleIndex = -1; // 14831
    if (this.geoProviders === null) { this.geoProviders = []; }
    if (geocodeSearchService.length === 0) {
      this.geoProviders = [ {
        name: 'geocodefarm',
        apiKey: 'a2338e05-e3cb425e93ad-109049bfb516',
        timeWait: 10000
      } ];
    } else {
      for (let i = 0; i < geocodeSearchService.length; ++i) {
        this.geoProviders.push(geocodeSearchService[i]);
        if (geocodeSearchService[i].name === 'google') {
          googleIndex = i;
        }
      }
    }
    this.initObj = options;
    this.currentProviderReverseIndex = 0;
    this.currentProviderLookUpIndex = 0;
    // this.instance(this.geoProviders[this.currentProviderReverseIndex]);
    if (geocodeSearchService.country ) { this.country = geocodeSearchService.country; }
    if (geocodeSearchService.language ) { this.language = geocodeSearchService.language; }


    this.MapGeo = pInstance;
    this.map = map;
    this.EPSG = EPSG;
    this.isInit = true;

    // 14831
    // console.log('%c googleIndex = ' + googleIndex + ', this.geoProviders.length = ' + this.geoProviders.length, 'color:blue');
    if (googleIndex === 0) {
      this.instance(this.geoProviders[googleIndex]);
    }
  }

  instance(geo) {
    let provider: any = {};
    this.lookUpGoogle = false;
    switch (geo.name) {
      case 'geocodefarm':
        provider = this.sclMapGeoCodeFarmService;
        break;
      case 'google':
        provider = this.sclMapGeoGoogleService;
        this.lookUpGoogle = true;
        break;
      case 'vicmap':
        provider = this.sclMapGeoVicMapService;
        break;
      case 'psma':
        provider = this.sclMapGeoPSMAService;
        break;
      case 'psmafarm':
        provider = this.sclMapGeoPsmaFarmService;
        break;
      case 'here':
        provider = this.sclMapGeoHereService;
        break;
      case 'doc':
        provider = this.sclMapGeoDocService;
        break;
      default :
        provider = this.sclMapGeoGoogleService;
        break;
    }
    provider.initObj = this.initObj;
    if (geo.apiKey) {
      provider.apiKey = geo.apiKey;
      // provider.apiKeyReverse = geo.apiKey;
    }
    if (geo.apiKeyReverse) { provider.apiKeyReverse = geo.apiKeyReverse; }
    if (geo.timeWait) { provider.waitTime = geo.timeWait; }
    if (geo.country) { provider.country = geo.country; }
    if (geo.state) { provider.state = geo.state; }
    if (geo.language) { provider.language = geo.language; }
    if (geo.autocompleteUrl) { provider.autocompleteUrl = geo.autocompleteUrl; }
    if (geo.addressUrl) { provider.addressUrl = geo.addressUrl; }
    if (geo.geocodeUrl) { provider.geocodeUrl = geo.geocodeUrl; }
    if (geo.geocodeUrlNext) { provider.geocodeUrlNext = geo.geocodeUrlNext; }
    if (geo.appId) { provider.appId = geo.appId; }
    if (geo.appCode) {
      provider.appCode = geo.appCode;
      // provider.apiKeyReverse = geo.appCode;
    }
    if (geo.radius) { provider.radius = geo.radius; }
    if (geo.filter) { provider.filter = geo.filter; }
    if (geo.geoJsonField) { provider.geoJsonField = geo.geoJsonField; }
    if (geo.relatedDocument) { provider.relatedDocument = geo.relatedDocument; }
    if (geo.dexieSearchFilter) { provider.dexieSearchFilter = geo.dexieSearchFilter; }
    if (geo.queryName) { provider.queryName = geo.queryName; }

    provider.geo = geo;

    if (this.lookUpGoogle) {
      provider.loadLookup = true;
      provider.setupLookUp();
    }
    // console.log('%c instance , lookUpGoogle = ' + this.lookUpGoogle, 'color:blue');

    return provider;
  }

  reverse( coor, cb, cbErr) {

    const mapGeo = this;
    const pCoor = coor;
    const pCb = cb;
    const pCbErr = cbErr;

    if (this.providerReverse == null) { this.providerReverse = this.instance(this.geoProviders[this.currentProviderReverseIndex]); }
    // use for testing psma
    if (this.providerReverse.geo.name === 'psma') {
      this.providerReverse.map = this.map;
      this.providerReverse.EPSG = this.EPSG;
      if (this.providerReverse.geo.radius == null) {
        coor[2] = this.providerReverse.psmaRadius;
      } else { coor[2] = (this.providerReverse.geo.radius < 1 ? 1 : this.providerReverse.geo.radius); }
      if (typeof this.providerReverse.geo.hasPrimaryAssetAddressLookup !== 'undefined' &&
        this.providerReverse.geo.hasPrimaryAssetAddressLookup !== null ) {
          this.providerReverse.hasPrimaryAssetAddressLookup = this.providerReverse.geo.hasPrimaryAssetAddressLookup; // 15393
      }
      this.providerReverse.setupReverse(this.providerReverse.geo);
    } else if (this.providerReverse.geo.name === "here") {
      if (typeof this.providerReverse.geo.hasPrimaryAssetAddressLookup !== 'undefined' &&
       this.providerReverse.geo.hasPrimaryAssetAddressLookup !== null ) {
          this.providerReverse.hasPrimaryAssetAddressLookup = this.providerReverse.geo.hasPrimaryAssetAddressLookup; // 15393
      }
      this.providerReverse.setupReverse(this.providerReverse.geo);
    }

    //
    this.providerReverse.reverse( coor , cb, cbErr, function() {
      //// logger.info("MapGeo.reverse timeout");
      mapGeo.currentProviderReverseIndex++;
      if (mapGeo.currentProviderReverseIndex < mapGeo.geoProviders.length) {
        mapGeo.providerReverse = mapGeo.instance(mapGeo.geoProviders[mapGeo.currentProviderReverseIndex]);
        mapGeo.providerReverse.autocompleteBox = mapGeo.autocompleteBox;
        mapGeo.reverse( pCoor, pCb, pCbErr);
      } else {
        if (cbErr && typeof cbErr === 'function') {
          cbErr('all time out');
        }
      }

    });
  }

  lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet ) {
    if (this.geoProviders.length === 0) {
      this.geoProviders = [ {
        name: 'geocodefarm',
        apiKey: 'a2338e05-e3cb425e93ad-109049bfb516',
        timeWait: 1000
      } ];
    }

    this.cbLookUp = cb;
    this.cbLookUpErr = cbErr;
    this.cbSelectOption = cbSelectOption;
    this.cbRemoveStreet = cbRemoveStreet;

    if (this.autocompleteBox == null) { this.autocompleteBox = params[0]; }

    if (this.providerLookUp == null) {
      this.providerLookUp = this.instance(this.geoProviders[this.currentProviderLookUpIndex]);
    }

    const mapGeo = this;
    if (params[0] == null) { params[0] = this.autocompleteBox; }
    if (params.length > 1 && params[1].trim().length === 0) { return; }
    if (this.lookUpGoogle) {
      this.providerLookUp.cbSelectOption = cbSelectOption;
    }
    this.providerLookUp.lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet, function() {
      //// logger.info("MapGeo.lookUp timeout");

      mapGeo.currentProviderLookUpIndex++;
      if (mapGeo.currentProviderLookUpIndex < mapGeo.geoProviders.length) {

        // new notice box
        const id = this.initObj.keyName + 'LoadingProvider';
        const len = document.querySelectorAll('#' + id).length; // angular.element(element).find('#' + id).length;
        if (len === 0) {
          const child = document.createElement('div');
          child.setAttribute('id', id);
          child.setAttribute('style', 'float:left; position:relative; overflow:hidden; background-color: black; ' +
            'opacity: 0.2; width: 200px; text-align: center; border-radius: 10px;');
          child.innerHTML = '<span style="color:white; display:inline-block;">Loading ' +
            mapGeo.geoProviders[mapGeo.currentProviderLookUpIndex].name + ' provider</span>';
          mapGeo.autocompleteBox.append(child);
        }
        // $compile( document.getElementById(id) )(scope);

        setTimeout(() => {
          console.log('TODO finish waiting');
          // if (angular.element(element).find('#' + id).length > 0) {
          //     angular.element(element).find('#' + id).remove();
          // }
          const lst = document.querySelectorAll('#' + id);
          if (lst && lst.length > 0) {
            for (let i = 0; i < lst.length; i++) {
              lst[i].remove();
            }
          }

          mapGeo.providerLookUp.removeLookUp();
          mapGeo.providerLookUp = mapGeo.instance(mapGeo.geoProviders[mapGeo.currentProviderLookUpIndex]);
          params[0] = mapGeo.autocompleteBox;
          mapGeo.lookUp(params, mapGeo.cbLookUp, mapGeo.cbLookUpErr, mapGeo.cbSelectOption, mapGeo.cbRemoveStreet);

        }, 1000);
      } else {
        if (cbErr && typeof cbErr === 'function') {
          cbErr('Address lookup for that text location has timed out.  Please try again.');
        }
      }
    });

  }

  selectionOption(tpl, model) {
    if (this.providerLookUp == null) { return; }// call this method invalid way

    this.providerLookUp.selectionOption(tpl, model, this.cbSelectOption);
  }

  removeStreet() {
    if (this.geoProviders.length === 0) {
      this.geoProviders = [ {
        name: 'geocodefarm',
        apiKey: 'a2338e05-e3cb425e93ad-109049bfb516',
        timeWait: 1000
      } ];
    }

    if ( this.providerLookUp == null ) {
      this.providerLookUp = this.instance(this.geoProviders[this.currentProviderLookUpIndex]);
    }
    // if ( this.providerLookUp.geo.name !== 'google') { return; }
    if (this.providerReverse && this.providerReverse.psmaPoints && this.providerReverse.psmaPoints.length > 0) {
      this.providerReverse.removeFeatures(true);
    }

    this.providerLookUp.removeStreet(this.cbRemoveStreet);
  }
  removeFeatures() {
    if (!this.isInit || this.geoProviders.length === 0 || this.providerReverse == null || this.providerReverse.geo.name !== 'psma') {
      return; }

    this.providerReverse.removeFeatures(true);
  }

  // **************************** other methods *****************************************
  // getProviderName(geoConfig){
  //    let name = "geocodefarm";//default value
  //    for(let i = 0; i < this.geoProviders.length; ++i){
  //        let mGeo = this.geoProviders[i];
  //        let sGeoField = "", sConfigField = "";
  //        for(let n in mGeo){
  //            if(n == "name") continue;
  //            sGeoField += n + mGeo[n];
  //        }
  //        for(let n in geoConfig){
  //            sConfigField += n + geoConfig[n];
  //        }
  //        if(sGeoField == sConfigField){
  //            name = mGeo.name;
  //            break;
  //        }
  //    }
  //    return name;
  // };

}
